import { Grid } from "@mui/material";
import * as React from "react";
import {
  Create,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
  NumberInput,
} from "react-admin";
import { StatusEnum, ProductSupplierEnum, ProductTypeEnum, StockStatusEnum } from "src/common/enum";
import { ProductCreateComponent } from "./ProductComponent";
import { FormTab, TabbedForm } from "src/enterprise/ra-rbac";

export const ProductCreate = () => {
  return (
    <Create component={ProductCreateComponent}>
      <TabbedForm>
        <FormTab label="General" name="general">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid container item rowSpacing={1} columnSpacing={2}>
              <Grid item sm={12} md={6}>
                <ReferenceInput
                  source="attributeSet"
                  reference="admin/product/attribute-sets"
                  validate={required()}
                >
                  <SelectInput
                    optionText={(record) => {
                      return record.name;
                    }}
                    label="Atribute Set"
                    source="id"
                    validate={required()}
                  />
                </ReferenceInput>
              </Grid>
            </Grid>
            <Grid container item sm={12} md={6} rowSpacing={1} columnSpacing={2}>
              <Grid item sm={12}>
                <TextInput source="name" validate={required()}/>
              </Grid>
              <Grid item sm={12}> 
                <TextInput
                  source="description"
                  sx={{
                    textarea: { minHeight: "215px" }
                  }}
                  fullWidth
                  multiline
                  validate={required()}
                />
              </Grid>
              <Grid item sm={12}> 
                <TextInput
                  source="shortDescription"
                  sx={{
                    textarea: { minHeight: "87.5px" }
                  }}
                  label="Short Description"
                  fullWidth
                  multiline
                  validate={required()}
                />
              </Grid>   
            </Grid>
            <Grid container item sm={12} md={6} rowSpacing={1} columnSpacing={2}>
                <Grid item sm={12}>
                  <TextInput source="sku" validate={required()} />
                </Grid>
                <Grid item sm={12}>
                  <SelectInput source="supplier" choices={ProductSupplierEnum} validate={required()} />
                </Grid>
                <Grid item sm={12}>
                  <TextInput source="supplier_sku" label="Supplier Sku"/>
                </Grid>
                <Grid item sm={12}>
                  <SelectInput source="type" choices={ProductTypeEnum} validate={required()} />
                </Grid>
                <Grid item sm={12}>
                  <NumberInput source="weight" min={0} validate={required()} />
                </Grid>
                <Grid item sm={12}>
                  <SelectInput source="status" choices={StatusEnum} validate={required()} />
                </Grid>
                <Grid item sm={12}> 
                  <SelectInput
                    source="stockStatus"
                    label="Stock Status"
                    choices={StockStatusEnum}
                    validate={required()}
                  />
                </Grid>
                <Grid item sm={12}>
                  <TextInput 
                  source="millName"
                  label="Mill Name"
                  />
                </Grid>
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="SEO" name="seo">
          <Grid container item sm={12} md={6} rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12}>
              <TextInput source="metaTitle"/>
            </Grid>
            <Grid item sm={12}>
              <TextInput
                source="metaDescription"
                sx={{
                  textarea: { minHeight: "87.5px" }
                }}
                fullWidth
                multiline
              />
            </Grid>
            <Grid item sm={12}>
              <TextInput source="metaKeywords"/>
            </Grid>
          </Grid>
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
